module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "comments"
    }
  }, [_c('div', [_c('main', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.commentGuidelines)
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.comments.length) + " " + _vm._s(_vm.comments.length === 1 ? 'Comment' : 'Comments'))]), _vm._v(" "), _c('comment-form', {
    attrs: {
      "postId": _vm.postId
    }
  }), _vm._v(" "), _c('div', {
    ref: "comments",
    staticClass: "comments"
  }, [(!_vm.expanded && _vm.firstComment) ? _c('comment', {
    attrs: {
      "comment": _vm.firstComment,
      "postId": _vm.postId
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.rootComments), function(comment, index) {
    return (_vm.expanded) ? _c('comment', {
      key: index,
      attrs: {
        "comment": comment,
        "postId": _vm.postId,
        "childComments": _vm.childComments
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [(_vm.comments.length > 1) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.toggleExpand
    }
  }, [_vm._v(_vm._s(_vm.expanded ? 'Show Less' : 'Load All Comments'))]) : _vm._e()])], 1), _vm._v(" "), _c('aside')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25203ef0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Comments.vue
// module id = 768
// module chunks = 1